import {
  createContext,
  ReactElement,
  ReactNode,
  useMemo,
  useState,
} from "react";

import { CollectionOrder, Sort } from "../generated/gql/graphql";
import { emptyFn } from "../utils/provider";

type CollectionsProviderContextType = {
  search?: string;
  setSearch(search?: string): void;

  sorting: CollectionOrder;
  setSorting(order: CollectionOrder): void;
};

const DEFAULT_COLLECTION_ORDER: CollectionOrder = {
  date_created: Sort.Desc,
};

export const CollectionsContext = createContext<CollectionsProviderContextType>(
  {
    setSearch: emptyFn,
    sorting: DEFAULT_COLLECTION_ORDER,
    setSorting: emptyFn,
  }
);

type Props = {
  children: ReactNode | ReactNode[];
};

export default function CollectionsProvider(props: Props): ReactElement {
  const { children } = props;

  const [search, setSearch] = useState<string>();
  const [sorting, setSorting] = useState<CollectionOrder>(
    DEFAULT_COLLECTION_ORDER
  );

  const values = useMemo(
    () => ({
      search,
      setSearch,
      sorting,
      setSorting,
    }),
    [search, sorting]
  );

  return (
    <CollectionsContext.Provider value={values}>
      {children}
    </CollectionsContext.Provider>
  );
}
